import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CalendarService } from 'src/app/services/calendar.service';
import { DataService } from 'src/app/services/data.service';
import { VacationWordService } from 'src/app/services/vacation-word.service';
import { CookieService } from 'ngx-cookie-service';
import { InstitutionDetailsService } from 'src/app/services/institution-details.service';

@Component({
  selector: 'app-issue-vacation-form-dialog',
  templateUrl: './issue-vacation-form-dialog.component.html',
  styleUrls: ['./issue-vacation-form-dialog.component.scss'],
})
export class IssueVacationFormDialogComponent implements OnInit {
  formDialog: FormGroup;
  isSubmited = false;
  loading = false;
  logo: Blob | null = null;
  logoLoading = true;
  logoBusy = false;
  logoError = '';

  errorMessage = '';
  successMessage = '';
  finished = false;

  constructor(
    public dialogRef: MatDialogRef<IssueVacationFormDialogComponent>,
    public calendarSvc: CalendarService,
    public dataService: DataService,
    private cookieService: CookieService,
    private wordSvc: VacationWordService,
    private institutionSvc: InstitutionDetailsService
  ) {
    this.formDialog = new FormGroup(
      {
        fromDate: new FormControl(null, Validators.required),
        toDate: new FormControl(null, Validators.required),
      },
      { validators: this.dateRangeValidator }
    );
  }

  private dateRangeValidator(group: FormGroup) {
    const from = group.get('fromDate')?.value;
    const to = group.get('toDate')?.value;
    if (from && to && new Date(from) > new Date(to)) {
      return { dateRange: true };
    }
    return null;
  }

  async ngOnInit() {
    this.logo = await this.institutionSvc.getLogo();
    this.logoLoading = false;
  }

  async onLogoSelected(logo: Blob) {
    this.logoBusy = true;
    const saved = await this.institutionSvc.saveLogo(logo);
    this.logoError = saved ? '' : 'שמירת הלוגו נכשלה';
    if (saved) {
      this.logo = logo;
    }
    this.logoBusy = false;
  }

  async save() {
    this.isSubmited = true;
    this.errorMessage = '';
    this.successMessage = '';

    if (this.formDialog.invalid) {
      if (this.formDialog.errors?.dateRange) {
        this.errorMessage = 'תאריך ההתחלה חייב להיות לפני תאריך הסיום';
      }
      return;
    }

    const fromDate = this.calendarSvc.transformDate(this.formDialog.value.fromDate, 'yyyy-MM-dd');
    const toDate = this.calendarSvc.transformDate(this.formDialog.value.toDate, 'yyyy-MM-dd');

    this.loading = true;
    this.calendarSvc.spinnerSubjectEmit(true);
    try {
      const vacations = await this.calendarSvc.getVacationsForRange(fromDate, toDate);
      if (!vacations || vacations.length === 0) {
        this.calendarSvc.spinnerSubjectEmit(false);
        this.loading = false;
        this.errorMessage = 'לא נמצאו חופשות או ימים מקוצרים בטווח התאריכים הנבחר.';
        this.finished = true;
        return;
      }

      const useLogin = this.cookieService.get('useLogin');
      const userName =
        useLogin === 'false'
          ? this.cookieService.get('SystemUserFullName')
          : this.cookieService.get('AcountFullName');

      await this.wordSvc.generateAndDownload({
        institutionNumber: this.dataService?.userModel?.InstitutionNumber || '',
        institutionName: this.dataService?.userModel?.InstitutionName || '',
        schoolYear: this.dataService?.userModel?.Year?.viewValue || '',
        fromDate,
        toDate,
        userName: userName || '',
        logo: this.logo,
        vacations,
      });

      this.calendarSvc.spinnerSubjectEmit(false);
      this.loading = false;
      this.successMessage = 'הטופס הופק והקובץ ירד למחשב שלך 📄';
      this.finished = true;
    } catch (err) {
      console.error(err);
      this.calendarSvc.spinnerSubjectEmit(false);
      this.loading = false;
      this.errorMessage = 'ארעה שגיאה בהפקת הטופס';
    }
  }

  close() {
    this.dialogRef.close(false);
  }
}
